import { __rest } from "tslib";
import React, { forwardRef } from 'react';
import { makeStyles, Breadcrumbs as MuiBreadcrumbs } from '@material-ui/core';
import { ChevronRightIcon } from '@getgo/chameleon-icons/react';
import { tokens } from '@getgo/chameleon-core';
const useStyles = makeStyles(() => ({
    root: {
        fontWeight: 400,
        fontSize: 14,
        color: tokens.neutral,
    },
}));
export const Breadcrumbs = forwardRef((_a, ref) => {
    var { children, separator } = _a, otherProps = __rest(_a, ["children", "separator"]);
    // Hooks
    const classes = useStyles();
    return (React.createElement(MuiBreadcrumbs, Object.assign({ innerRef: ref, className: classes.root, separator: separator || React.createElement(ChevronRightIcon, null) }, otherProps), children));
});
